/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Source: https://github.com/immersive-web/semantic-labels/blob/master/labels.json
/**
 * Enum for semantic labels.
 * For more details, see the {@link https://github.com/immersive-web/semantic-labels | Semantic Labels Documentation}.
 */
export var XRSemanticLabels;
(function (XRSemanticLabels) {
    XRSemanticLabels["Desk"] = "desk";
    XRSemanticLabels["Couch"] = "couch";
    XRSemanticLabels["Floor"] = "floor";
    XRSemanticLabels["Ceiling"] = "ceiling";
    XRSemanticLabels["Wall"] = "wall";
    XRSemanticLabels["Door"] = "door";
    XRSemanticLabels["Window"] = "window";
    XRSemanticLabels["Table"] = "table";
    XRSemanticLabels["Shelf"] = "shelf";
    XRSemanticLabels["Bed"] = "bed";
    XRSemanticLabels["Screen"] = "screen";
    XRSemanticLabels["Lamp"] = "lamp";
    XRSemanticLabels["Plant"] = "plant";
    XRSemanticLabels["WallArt"] = "wall art";
    XRSemanticLabels["GlobalMesh"] = "global mesh";
    XRSemanticLabels["Other"] = "other";
})(XRSemanticLabels || (XRSemanticLabels = {}));
//# sourceMappingURL=labels.js.map